import { render } from "./SubscriptionsPage.vue?vue&type=template&id=22419cbc"
import script from "./SubscriptionsPage.vue?vue&type=script&lang=js"
export * from "./SubscriptionsPage.vue?vue&type=script&lang=js"

import "./SubscriptionsPage.vue?vue&type=style&index=0&id=22419cbc&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__